module.exports = __webpack_public_path__ + "img/group.52f52490.svg";